export default __webpack_public_path__ + "static/media/attack-page.5dd7ff43.png";